export const CONFIRM_RESPONDENT = 'CONFIRM_RESPONDENT';
export const CONFIRM_RESPONDENT_RESPONSE = 'CONFIRM_RESPONDENT_RESPONSE';